import React from "react";

export default function AnnouncementMarquee() {
  return (
    <>
      <style>
        {`
          .pg-marquee-wrapper {
            width: 100%;
            overflow: hidden;
            background: #ff7a18;
            color: #ffffff;
            font-size: 14px;
            font-weight: 500;
            padding: 8px 0;
          }

          .pg-marquee-track {
            display: inline-block;
            white-space: nowrap;
            animation: pg-marquee-scroll 30s linear infinite;
          }

          .pg-marquee-wrapper:hover .pg-marquee-track {
            animation-play-state: paused;
          }

          @keyframes pg-marquee-scroll {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(-100%);
            }
          }
        `}
      </style>

      <div className="pg-marquee-wrapper">
        <div className="pg-marquee-track">
          📚 <strong>Foundation Batch Registration Open</strong> | For Students of
          8th to 12th Standard | Early Bird Offer Available! Enroll Now and Boost
          Your Future 🚀 
        
        </div>
      </div>
    </>
  );
}
